import { applyMiddleware, compose, createStore } from "redux";
import { rootReducer } from "./root-reducer";
import apiMiddleware from "./middleware/api-middleware";
import thunkMiddleware from "redux-thunk";
import { persistStore } from "redux-persist";

let store = createStore(rootReducer, compose(applyMiddleware(thunkMiddleware, apiMiddleware)));

if (process.env.NODE_ENV !== "production") {
  const { composeWithDevTools } = require("redux-devtools-extension");
  store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunkMiddleware, apiMiddleware)));
}

export const persistor = persistStore(store);
export default store;
